/**
 * By pass React to set status directly into DOM because setState is batched & too late
 */
export const setStatus = (status: string) => {
  const statusElement = document.getElementById("status");
  if (statusElement) {
    statusElement.innerHTML = status;
  }
};
